import { useCallback, useContext } from 'react';
import { getCampaignPageUrl } from '@bingads-webui-campaign-react/shared-app-capi';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';

export const useNavigateToConverstionGoalCreationWorkflow = () => {
  const serverContext = useContext(ServerContext);
  return useCallback(() => {
    const url = getCampaignPageUrl(serverContext, 'conversiongoals/create');
    window.open(url);
  }, [serverContext]);
};
